module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-nw.f336a8ae.png";